import RoundButton from "features/shared/components/buttons/RoundButton";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import React, { ReactElement } from "react";
import RequirementSimplifiedDTO from "../dtos/RequirementSimplifiedDTO";

import styles from "./requirementdashboardrow.module.scss";

interface IProps {
  requirement: RequirementSimplifiedDTO;
}

const RequirementDashboardRow: React.FC<IProps> = (props) => {
  // props
  const { requirement } = props;

  // sub renders
  const renderState = (requirement: RequirementSimplifiedDTO):ReactElement => {
    if (requirement.resolveDate) {
      return (
        <>
          <span className="d-inline-block rounded-circle p-1 mr-1 bg-success"></span>
          <small className="text-success text-truncate d-inline-block">{requirement.actualState}</small>
        </>
      );
    } else {
      return (
        <>
          <span className="d-inline-block rounded-circle p-1 mr-1 bg-warning"></span>
          <small className="text-warning text-truncate d-inline-block">{requirement.actualState}</small>
        </>
      );
    }
  }

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col-2 pr-2">
        <div className="d-flex flex-column flex-sm-row flex-lg-column align-items-center text-muted">
          <small className={styles.dateItem}>
            <DateFormatter date={requirement.issueDate!} />
          </small>
        </div>
      </div>
      <div className="col-8 col-sm-9 col-lg-8">
        <div className="row no-gutters align-items-center">
          <div className="col-sm-6 col-lg-12">
            <div className="text-truncate">
              {requirement.requirementType?.name}
            </div>
          </div>
          <div className="col-sm-6 col-lg-12 pl-sm-3 pl-lg-0">
            <div className="d-flex align-items-center">
              {renderState(requirement)}
            </div>
          </div>
        </div>
      </div>
      <div className="col-2 col-sm-1 col-lg-2 text-right">
        <RoundButton asLink to={`requirements/${requirement.requirementId}`} />
      </div>
    </div>
  );
};

export default RequirementDashboardRow;